/**
 * Application Entry Point
 * Sets up URLPattern polyfill for browsers without native support
 * and imports the root application component
 */
import {URLPattern} from 'urlpattern-polyfill';

// Add polyfill for browsers without native URLPattern support (Firefox, Safari)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (!(globalThis as any).URLPattern) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).URLPattern = URLPattern;
}

// Import root application component
import './app/app.component.js';
